import { UUID } from '@finxone-platform/shared/base-types';
import {
  AccordionDefaultState,
  CarouselActiveSlideAlignment,
  CarouselDataType,
  CarouselScrollBehavior,
  Constants,
  GridPosition,
  WORKFLOW_POPUPS,
  WidgetNames,
  WidgetTitles,
  WorkflowWidgetConfig,
} from '@finxone-platform/shared/sys-config-types';

export const sectionWidgetConfig = {
  widgetTypeConfig: 'new',
  uniqueId: Math.floor(Math.random() * (1000000000 + 1)),
  name: WidgetNames.SECTION,
  widgetConfiguration: {
    widgetDisplayName: 'Section',
    widgetConfigDisplayName: WidgetTitles.SECTION,
    attributes: {
      outerCss: 'height: 100px;',
      elementsConfig: [],
      css_config: {},
      widgetProperties: {
        textContent: '',
      },
    },
    isRemovable: true,
  },
  gridPosition: undefined as unknown as GridPosition,
  widgetIconPath: 'section-widget',
  childComponents: [],
} as WorkflowWidgetConfig;

export const twoColumnWidgetConfig = {
  widgetTypeConfig: 'new',
  uniqueId: Math.floor(Math.random() * (1000000000 + 1)),
  name: WidgetNames.TWO_COLUMN,
  widgetConfiguration: {
    widgetDisplayName: 'Multi Column',
    widgetConfigDisplayName: WidgetTitles.MULTI_COLUMN,
    attributes: {
      outerCss: 'height: 100px;',
      elementsConfig: [],
      css_config: {
        ...Constants.defaultBaseCssConfig,
        borderWidthTop: 0,
        borderWidthBottom: 0,
        borderWidthLeft: 0,
        borderWidthRight: 0,
        borderWidthUnit: 'px',
        columnGap: 0,
        columnGapUnit: 'px',
        borderClass: 'none',
      },
      widgetProperties: {
        textContent: '',
        columnOneOuterCss: '',
        columnTwoOuterCss: '',
        columnOnePercent: 50,
        selectedNoOfColumn: 2,
        selectedColumnRange: [],
        selectedSplitType: 'even',
        columnConfigs: [
          {
            outerCssConfig: '',
            containerName: 'Column: 1',
          },
          {
            outerCssConfig: '',
            containerName: 'Column: 2',
          },
        ],
      },
    },
    isRemovable: true,
  },
  gridPosition: undefined as unknown as GridPosition,
  widgetIconPath: 'multi-column',
  childComponents: [[], []],
} as WorkflowWidgetConfig;

export const tabWidgetConfig = {
  widgetTypeConfig: 'new',
  uniqueId: Math.floor(Math.random() * (1000000000 + 1)),
  name: WidgetNames.TAB,
  widgetConfiguration: {
    widgetDisplayName: 'Tabs',
    widgetConfigDisplayName: WidgetTitles.TAB,
    attributes: {
      elementsConfig: [],
      css_config: {
        elementStyling: {
          tabCss: `hlm-tabs-list {\n}\nhlm-tabs-list button {\n}\nhlm-tabs-list button:hover {\n}\nhlm-tabs-list button[data-state=active] {\n}`,
        },
      },
      widgetProperties: {
        textContent: '',
        tabConfigs: [
          {
            title: 'Tab 1',
            tabRef: 'tab1',
            containerName: 'Tab: 1',
          },
          {
            title: 'Tab 2',
            tabRef: 'tab2',
            containerName: 'Tab: 2',
          },
          {
            title: 'Tab 3',
            tabRef: 'tab3',
            containerName: 'Tab: 3',
          },
        ],
        globalStyling: true,
      },
    },
    isRemovable: true,
  },
  gridPosition: undefined as unknown as GridPosition,
  widgetIconPath: 'tab-widget',
  childComponents: [[], [], []],
} as WorkflowWidgetConfig;

export const spacerWidgetConfig = {
  widgetTypeConfig: 'new',
  uniqueId: Math.floor(Math.random() * (1000000000 + 1)),
  name: WidgetNames.SPACER,
  widgetConfiguration: {
    widgetDisplayName: WidgetTitles.SPACER,
    widgetConfigDisplayName: WidgetTitles.SPACER,
    attributes: {
      outerCss: '',
      elementsConfig: [],
      css_config: {
        height: 15,
        heightUnit: 'px',
      },
      widgetProperties: {
        textContent: '',
      },
    },
    isRemovable: true,
  },
  gridPosition: undefined as unknown as GridPosition,
  widgetIconPath: 'spacer-widget',
} as WorkflowWidgetConfig;

export const formWidgetConfig = {
  widgetTypeConfig: 'new',
  uniqueId: Math.floor(Math.random() * (1000000000 + 1)),
  name: WidgetNames.FORM_WIDGET,
  widgetConfiguration: {
    widgetDisplayName: WidgetTitles.FORM_WIDGET,
    widgetConfigDisplayName: WidgetTitles.FORM_WIDGET,
    attributes: {
      elementsConfig: [],
      name: WidgetNames.FORM_WIDGET,
      css_config: {},
      widgetProperties: {
        textContent: '',
        formsConfig: {
          formID: '',
          numberOfInputs: 0,
          clearFormData: false,
        },
      },
    },
    isRemovable: true,
  },
  popupType: WORKFLOW_POPUPS.FORM_WIDGET_POPUP,
  gridPosition: undefined as unknown as GridPosition,
  widgetIconPath: 'form-widget',
  childComponents: [],
} as WorkflowWidgetConfig;

export const inputWidgetConfig = {
  widgetTypeConfig: 'new',
  uniqueId: Math.floor(Math.random() * (1000000000 + 1)),
  name: WidgetNames.INPUT_WIDGET,
  widgetConfiguration: {
    widgetDisplayName: WidgetTitles.INPUT_WIDGET,
    widgetConfigDisplayName: WidgetTitles.INPUT_WIDGET,
    attributes: {
      elementsConfig: [],
      name: WidgetNames.INPUT_WIDGET,
      css_config: {},
      widgetProperties: {
        textContent: '',
      },
    },
    isRemovable: true,
  },
  gridPosition: undefined as unknown as GridPosition,
  widgetIconPath: 'input-field-widget',
} as WorkflowWidgetConfig;

export const carouselWidgetConfig = {
  widgetTypeConfig: 'new',
  uniqueId: Math.floor(Math.random() * (1000000000 + 1)),
  name: WidgetNames.GENERIC_CAROUSEL_WIDGET,
  widgetConfiguration: {
    widgetDisplayName: WidgetTitles.GENERIC_CAROUSEL_WIDGET,
    widgetConfigDisplayName: WidgetTitles.GENERIC_CAROUSEL_WIDGET,
    attributes: {
      outerCss: 'height: 100px;',
      elementsConfig: [],
      css_config: {},
      widgetProperties: {
        textContent: '',
        dataType: CarouselDataType.NONE,
        numberOfSlides: 2,
        carouselConfig: {
          carouselScrollMode: CarouselScrollBehavior.SNAP_TO_SLIDE,
          activeSlidePosition: CarouselActiveSlideAlignment.LEFT_ALIGNED,
          slideSpacingUnit: 'px',
          slideSpacingValue: 10,
          isInfiniteLoopingEnabled: false,
          showPaginationIndicators: true,
          isAutoScrollEnabled: false,
          autoScrollInterval: 3,
          previewAutoScrollInWorkflow: false,
          activePaginationIndicatorColor: '#111827', // Default static color for active pagination dot
          inactivePaginationIndicatorColor: '#E5E7EB', // Default static color for inactive pagination dot
        },
      },
    },
    isRemovable: true,
  },
  gridPosition: undefined as unknown as GridPosition,
  widgetIconPath: 'carousel-grey',
  childComponents: [[], []],
} as WorkflowWidgetConfig;

export const accordionWidgetConfig = {
  widgetTypeConfig: 'new',
  uniqueId: new UUID().toString(),
  name: WidgetNames.ACCORDION_WIDGET,
  widgetConfiguration: {
    widgetDisplayName: WidgetTitles.ACCORDION_WIDGET,
    widgetConfigDisplayName: WidgetTitles.ACCORDION_WIDGET,
    attributes: {
      outerCss: '',
      elementsConfig: [],
      css_config: {
        elementStyling: {
          headerCss: '.collapsed{}\n.expanded{}',
          contentCss: '',
        },
      },
      widgetProperties: {
        textContent: '',
        collapsedIcon: '',
        accordionConfigs: [
          {
            title: '<p class="typog-sm">Accordion 1</p>',
            containerName: 'Accordion: 1',
            css: '',
            defaultState: AccordionDefaultState.COLLAPSED,
          },
          {
            title: '<p class="typog-sm">Accordion 2</p>',
            containerName: 'Accordion: 2',
            css: '',
            defaultState: AccordionDefaultState.COLLAPSED,
          },
          {
            title: '<p class="typog-sm">Accordion 3</p>',
            containerName: 'Accordion: 3',
            css: '',
            defaultState: AccordionDefaultState.COLLAPSED,
          },
          {
            title: '<p class="typog-sm">Accordion 4</p>',
            containerName: 'Accordion: 4',
            css: '',
            defaultState: AccordionDefaultState.COLLAPSED,
          },
        ],
      },
    },
    isRemovable: true,
  },
  gridPosition: undefined as unknown as GridPosition,
  widgetIconPath: 'accordion',
  childComponents: [[], [], [], []],
} as WorkflowWidgetConfig;
